import { provisionUsersForVessel } from "../../services/login/provisionUsersForVessel";

export const prepareAssignedVessel = async (selectedShipId) => {
  return provisionUsersForVessel(selectedShipId);
};
